import './RefreshIndicator.scss';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setRefreshInterval } from '../../storeRedux';

export default function RefreshIndicator() {
    const { t } = useTranslation();
    const [showMenu, setShowMenu] = useState(false);
    const refreshInterval = useSelector(state => state.REFRESH_INTERVAL);
    const isRefreshing = useSelector(state => state.IS_REFRESHING);
    const theme = useSelector(state => state.APP_THEME);
    const dispatch = useDispatch();

    const intervals = [
        { value: 20000, label: '20s' },
        { value: 40000, label: '40s' },
        { value: 60000, label: '60s' },
        { value: 90000, label: '90s' }
    ];

    const handleIntervalChange = (value) => {
        dispatch(setRefreshInterval(value));
        setShowMenu(false);
    };

    const currentInterval = intervals.find(i => i.value === refreshInterval)?.label || '20s';

    return (
        <div className="refresh-indicator">
            <button
                className={`refresh-button ${theme === 'dark' ? 'dark' : ''}`}
                onClick={() => setShowMenu(!showMenu)}
                title={t('common:autoRefreshSettings')}
            >
                {/* SVG иконка обновления */}
                <svg
                    className={isRefreshing ? 'spinning' : ''}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 12C4 7.58172 7.58172 4 12 4C14.5264 4 16.7792 5.17107 18.2454 7M20 12C20 16.4183 16.4183 20 12 20C9.47362 20 7.22075 18.8289 5.75463 17"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M18 3V7H14"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6 21V17H10"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span className="refresh-interval-label">{currentInterval}</span>
            </button>

            {showMenu && (
                <>
                    {/* Overlay для закрытия меню при клике вне */}
                    <div className="refresh-menu-overlay" onClick={() => setShowMenu(false)} />

                    <div className={`refresh-menu ${theme === 'dark' ? 'dark' : 'light'}`}>
                        <div className="refresh-menu-title">{t('common:refreshInterval')}</div>
                        {intervals.map(interval => (
                            <button
                                key={interval.value}
                                className={`refresh-menu-item ${refreshInterval === interval.value ? 'active' : ''}`}
                                onClick={() => handleIntervalChange(interval.value)}
                            >
                                <span>{interval.label}</span>
                                {refreshInterval === interval.value && (
                                    <span className="checkmark">✓</span>
                                )}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
